<template>
    <div data-cy="container_month_picker">
        <div class="text-sm" :class="[isError ? 'text-red-500' : 'text-gray-800']">
            {{inputLbl.name}}
        </div>
        <div class="relative">
            <div class="grid grid-cols-2 gap-2">
                <div>
                    <InputDropdown
                            data-cy="input_month_dropdown"
                            v-model:inputValue="monthInput"
                            :inputLbl="inputLbl.month"
                            :itemList="monthList"
                            :errorInfo="errorInfoDate[0]"
                            :isShowError="isShowError"
                            :isSubmitted="isSubmitted"
                            @update:inputValue="onValueUpdate()"
                            @click="onClick('month')"
                    ></InputDropdown>
                </div>
                <div>
                    <InputDropdown
                            data-cy="input_year_dropdown"
                            v-model:inputValue="yearInput"
                            :inputLbl="inputLbl.year"
                            :itemList="yearList"
                            :errorInfo="errorInfoDate[1]"
                            :isShowError="isShowError"
                            :isSubmitted="isSubmitted"
                            @update:inputValue="onValueUpdate()"
                            @click="onClick('year')"
                    ></InputDropdown>
                </div>
            </div>
            <!-- error msg -->
            <div class="text-red-500 text-sm absolute bottom-0 left-0 w-full" v-if="isError">
                {{getErrorMsg}}
            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import { FormHelper, DropdownListValue } from "@/helper/FormHelper.js";
import DatetimeHelper from '@/helper/DatetimeHelper';
//component
import InputDropdown from './InputDropdown.vue';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';

/**
 * @property {Number} startYear (optional) start year example 2021
 * @property {inputLbl} inputLbl (required) text label example lbl.history.monthPicker
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} errorInfo (optional) Validate result. example : { isValid: true, msg: '',}
 */
export default {
    name: 'MonthPickerDropdown',
    mixins: [LocaleMixin],
    components: {
        InputDropdown,
    },
    props: {
        inputValue:     { type: [Date, String, Number], default: null },
        startYear:      { type: Number, default: 0 },

        inputLbl:       { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        errorInfo:      { type: Object, default: null },
        isShowDate:     { type: Boolean, default: true },
    },
    data: function() {
        return {
            monthInput: '',
            yearInput: '',

            monthList: [],
            yearList: [],

            errorInfoDate: FormHelper.genErrorInfo(2),
        };
    },
    created: function() {
        this.setMonthList();
        this.setYearList();
        this.initInput();
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            if (this.isShowError && this.isSubmitted && !this.errorInfo.isValid) {
                return this.errorInfo.msg
            }
            return '';
        }
    },
    methods: {
        //#region setup
        setMonthList: function() {
            let monthListItem = new DropdownListValue();

            let lbl = this.lbl;
            let months = lbl.date.month_full;
            for (let i in months) {
                let index = parseInt(i, 10) + 1 + '';
                // let index = parseInt(i, 10) + '';
                monthListItem.add(months[i], index);
            }
            this.monthList = monthListItem.getList();
        },
        setYearList: function() {
            let yearListItem = new DropdownListValue();
            let yearLength = 3;


            let currentYear = parseInt(new Date().getFullYear(), 10);
            let yearText = currentYear;
            let localeCode = this.localeCode;

            if (this.startYear > 0) {
                yearLength = currentYear - this.startYear;
            }

            if (localeCode == 1054) {
                yearText = yearText + 543;
            }

            for (let i=0 ; i<yearLength ; i++) {
                yearListItem.add(yearText-i + '', currentYear-i + '');
            }
            this.yearList = yearListItem.getList();
        },
        initInput: function() {
            if (Util.isEmptyStr(this.inputValue)) {
                this.monthInput = null;
                this.yearInput = null;
            } else {
                let date = null;
                let checkDate = this.inputValue.toString();
                if (this.inputValue instanceof Date) {
                    date = this.inputValue;
                } else if (checkDate.match(/^-{0,1}[0-9]+$/)) {
                    date = DatetimeHelper.unixTimestampToDate(this.inputValue);
                } else {
                    date = DatetimeHelper.stringToDate(this.inputValue, 'YYYY-MM-DD');
                }
                let m = date.getMonth() + 1;
                let y = date.getFullYear();

                this.monthInput = m;
                this.yearInput = y;
            }

            // this.$refs['dropdown-month'].setValue(this.monthInput);
            // this.$refs['dropdown-year'].setValue(this.yearInput);

            this.onValueUpdate();
        },
        //#endregion setup

        onValueUpdate: function() {
            if (this.validateInput()) {
                let inputDate = DatetimeHelper.getDateByValue(this.yearInput, this.monthInput, 1);
                let timestamp = DatetimeHelper.convertDateToTimeStampUnix(inputDate);
                let formated = DatetimeHelper.dateIsoFormat(inputDate);
                
                if(!this.isShowDate){
                    formated = DatetimeHelper.dateIsoFormatNoDate(inputDate);
                }
                
                let value = {
                    date: inputDate,
                    timestamp: timestamp,
                    formated: formated,
                };

                // console.log('input value', value);
                this.$emit("update:inputValue", formated);
                this.$emit("onDateChange", value);
            }
        },
        validateInput: function() {
            if (this.errorInfo == null) {
                if (Util.isEmptyStr(this.yearInput) || Util.isEmptyStr(this.monthInput)) {
                    return false;
                }
                return true;
            } else {
                let dateValidate = FormHelper.validate(this.errorInfoDate);

                this.errorInfo.setValid(dateValidate);
                this.errorInfo.setMsg(this.inputLbl.required);
                return dateValidate;
            }
        },
        onClick: function(data){
            this.$emit('onClick', data);
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
